import i18n from './i18n';

export const FlashDefinition = {
  uploadAssetError: {
    context: [{ detail: i18n.uploadAssetError }],
    status: 'error',
  },
};
